// -----------------------------------------------------------------------------
// Normalizer for Moonshot API
// -----------------------------------------------------------------------------
//
// -----------------------------------------------------------------------------
// TO USE THIS SERVICE
// -----------------------------------------------------------------------------
// import { toModel } from '../services/normalizer'
//
// const payload = await http.get(uri, params)
// const model = toModel(payload)
//
// -----------------------------------------------------------------------------
// FOR MANY ITEMS REQUESTS
// -----------------------------------------------------------------------------
// If the query is a many items request, the result will be a Collection model.
// The Collection.items array will contain the specific model types (e.g. Order)
//
// Collection.items = [<Order>, <Order>]
//
// -----------------------------------------------------------------------------
// FOR SINGLE ITEM REQUESTS
// -----------------------------------------------------------------------------
// If the query is a single item request, the result will be the specific type.
// (e.g. Order)
//
// -----------------------------------------------------------------------------
import JointNormalizer from 'joint-normalizer'
import models from '../models'

// Initialize normalizer (with model factory)
const normalizer = new JointNormalizer({
  payloadSpec: 'json-api',
  models,
  relationNameMap: {},
  debugInit: false,
  debug: false,
  debugToModel: false,
  logNamespace: '[normalizer]'
})

export function toModel (payload) {
  return normalizer.normalizePayload(payload, true)
}

export default normalizer
